module.exports = __webpack_public_path__ + "src/assets/img/sound-green.c5ce2de2.svg";